import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const titleFromPath = (pathname) => {
  if (!pathname || pathname === "/") {
    return localStorage.getItem("token") ? "Dashboard" : "Login";
  }
  return pathname
    .replace(/^\//, "")
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const GARouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const title = titleFromPath(location.pathname);
    document.title = title;

    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname,
      page_title: title,
    });
  }, [location.pathname]);

  return null;
};

export default GARouteTracker;
